export default __webpack_public_path__ + "static/media/smart-contract-bg.3eedfb97.svg";